<app-popup [title]="languageService.LNG('Label.QuickSearch')"
  [width]="width"
  [popupVisible]="popupVisible"
  (closeClicked)="popupVisible = false"
  (shown)="searchValue = null; textRef.instance.focus()"
  (window:keydown.control.alt.q)="popupVisible = !popupVisible">
  <dx-text-box #textRef [(value)]="searchValue" [placeholder]="placeholder" showClearButton="true" (onEnterKey)="onSearch()"></dx-text-box>
</app-popup>
